import React from "react";
import UserGreenIcon from "../../../Common/svg/usergreenicon";
import { formatPrice } from "../../../../utils/formatPrice";

const OrderSummary = ({ items, pricing }) => {
  const factor = pricing.currency_factor;
  const total_amount = formatPrice(factor, pricing.total_amount);
  const final_amount = formatPrice(factor, pricing.final_amount);
  const service_fee = formatPrice(factor, pricing.service_fee);
  const tax_amount = formatPrice(factor, pricing.tax_amount);
  const delivery_fee = formatPrice(factor, pricing.delivery_fee);
  const discount_amount = formatPrice(factor, pricing.discount_amount);
  const paid_amount = formatPrice(factor, pricing.paid_amount);
  const tip_amount = formatPrice(factor, pricing.tip_amount);
  
  return (  
    <div className="col-md-6 pe-0">
      <div className="card rounded-4 shadow-sm ">
        <div className="card-body">
          <h5 className="text-smoke font16 font700 mb-1">عناصر الطلب </h5>
          <table className="table">
            <thead className="border-b border-gray-200">
              <tr>
                <th className="py-2 px-1">المنتج</th>
                <th className="py-2 px-1">الكمية</th>
                <th className="py-2 px-1">السعر</th>
                <th className="py-2 px-1">المجموع</th>
              </tr>
            </thead>
            <tbody>
              {items?.map((item, index) => {
                const total_price = formatPrice(factor, item.total_price);
                const unit_price = formatPrice(factor, item.unit_price);

                return (
                  <tr key={index} className="border-b border-gray-100">
                    <td className="py-2 px-1">
                      {item?.product?.name}
                      <div className=" text-green">{item.selected_options}</div>
                      <div className="fw-bold"></div>
                    </td>
                    <td className="py-2 px-1">{item.quantity}</td>
                    <td className="py-2 px-1">
                      {item.symbol_currency}
                      {unit_price}
                    </td>
                    <td className="py-2 px-1">
                      {item?.symbol_currency}
                      {total_price}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <div className="text-right w-100 mt-3">
            <div className="d-flex justify-content-between w-100">
              <span className="text-smoke">المجموع الفرعي</span>
              <span  className="text-smoke">
                {pricing.symbol_currency}
                {total_amount}
              </span>
            </div>
            <div className="d-flex justify-content-between w-100">
              <span className="text-smoke">رسوم التوصيل</span>
              <span  className="text-smoke">
                {pricing.symbol_currency}
                {delivery_fee}
              </span>
            </div>
            <div className="d-flex justify-content-between w-100">
              <span className="text-smoke"> تكلفة الخدمة</span>
              <span  className="text-smoke">
                {pricing.symbol_currency}
                {service_fee}
              </span>
            </div>
            <div className="d-flex justify-content-between w-100">
              <span className="text-smoke">الضريبة</span>
              <span className="text-smoke">
                {pricing.symbol_currency}
                {tax_amount}
              </span>
            </div>
            <div className="d-flex justify-content-between w-100">
              <span className="text-smoke">الخصم</span>
              <span  className="text-smoke">
                {pricing.symbol_currency}
                {discount_amount}
              </span>
            </div>
            <div className="d-flex justify-content-between w-100">
              <span className="text-smoke">المبلغ المدفوع</span>
              <span  className="text-smoke">
                {pricing.symbol_currency}
                {paid_amount}
              </span>
            </div>
            <div className="d-flex justify-content-between w-100">
              <span className="text-smoke">المبلغ الإضافي </span>
              <span  className="text-smoke">
                {pricing.symbol_currency}
                {tip_amount}
              </span>  
            </div>
            <div className="d-flex justify-content-between w-100 fw-bold">
              <span className="fs-4 fw-bold">الإجمالي</span>
              <span className="fs-4 fw-bold text-green">
                {pricing.symbol_currency}
                {final_amount}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderSummary;
